import { useCallback, useMemo } from "react";
import {
  TenantPaginateResponse,
  TenantStatus,
} from "core/features/tenants/typings/tenant";
import useToggleTenantStatus from "core/features/tenants/hooks/useToggleTenantStatus";
import { showErrorAxios } from "infra/helpers/alerta";
import { Image, Switch } from "@chakra-ui/react";
import { useLoading } from "components/GlobalLoading";

function useTenantListagemColumns(onToggleStatus?: () => any) {
  const { mutate: handleToggleStatus, isLoading } = useToggleTenantStatus();

  const _handleToggleStatus = useCallback(
    (tenantId: string, checked: boolean) => {
      const newStatus = checked ? TenantStatus.Ativo : TenantStatus.Inativo;
      handleToggleStatus(
        {
          tenantId,
          status: newStatus,
        },
        {
          onSuccess: onToggleStatus,
          onError: (err) => {
            showErrorAxios(
              err,
              "Não foi possível alterar o status do condomínio."
            );
          },
        }
      );
    },
    [handleToggleStatus, onToggleStatus]
  );

  useLoading(isLoading);

  return useMemo(() => {
    return [
      {
        title: "",
        render: (item: TenantPaginateResponse) => {
          return item.imagemUrl ? (
            <Image src={item.imagemUrl} rounded="full" h="35px" />
          ) : null;
        },
      },
      {
        title: "Nome",
        dataIndex: "nome",
      },
      {
        title: "Estado",
        dataIndex: "estado",
      },
      {
        title: "Cidade",
        dataIndex: "cidade",
      },
      {
        title: "Status",
        render: (original: TenantPaginateResponse) => {
          const isChecked =
            original.status.id?.toLowerCase() ===
            TenantStatus.Ativo.toLowerCase();

          return (
            <div>
              <Switch
                onChange={() => _handleToggleStatus(original.id, !isChecked)}
                isChecked={isChecked}
              />
            </div>
          );
        },
      },
    ];
  }, [_handleToggleStatus]);
}

export default useTenantListagemColumns;
